import React from "react";
import { useTranslation } from "react-i18next";

import {
    Card,
    SectionHeader,
    CardTitle,
    ToggleContainer,
    ToggleLabel,
    Toggle,
} from "./styled";

type LegalInfoCardProps = {
    mainColor: string;
    showLegalInfo: boolean;
    onToggleShowLegalInfo: () => void;
};

export function LegalInfoCard({
    mainColor,
    showLegalInfo,
    onToggleShowLegalInfo,
}: LegalInfoCardProps): JSX.Element {
    const { t } = useTranslation();

    return (
        <Card data-testid="scan-to-misc-legal-info-card">
            <SectionHeader>
                <CardTitle>{t("Legal information")}</CardTitle>
                <ToggleContainer>
                    <ToggleLabel>{t("Show legal information")}</ToggleLabel>
                    <Toggle
                        data-testid="scan-to-misc-show-legal-info-toggle"
                        isActive={showLegalInfo}
                        mainColor={mainColor}
                        onClick={onToggleShowLegalInfo}
                        aria-label={t("Show legal information")}
                    />
                </ToggleContainer>
            </SectionHeader>
        </Card>
    );
}
